import { createStore } from 'redux' 
import Reducers from './Reducers' 
 
const Store = createStore(Reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) 
 
export default Store;



// WEBPACK FOOTER //
// ./src/modules/state/Store.js